<template>
  <div id="config-contracts-wrapper">
    <item-tile
      v-for="(item, index) in contracts"
      :key="index"
      class="contract-item"
      :heading="item.contractName"
      :selected="true"
      :secondaryIcons="['pencil']"
      @primary-icon-clicked="initiateDelete(item, index)"
      @secondary-icon-clicked="initiateEdit(item, index)"
    />
    <item-tile
      class="contract-item"
      :selected="false"
      heading="Add New Contract"
      @click="toggleCreationActive"
    />
    <contract-creation
      v-if="creationActive"
      :contract="edit.contract"
      :processing="edit.processing"
      @close="toggleCreationActive"
      @add-contract="callDb"
    />
    <contract-delete
      v-if="del.contract"
      :subject="del.contract"
      :processing="del.processing"
      @close="closeDelete"
      @confirm="confirmDelete"
    />
  </div>
</template>

<script>
import ContractCreation from "./Modals/Contracts/ContractCreation.vue";
import ContractDelete from "./Modals/Contracts/Delete.vue";
import ItemTile from "@/Components/UI/ItemTile.vue";
export default {
  data() {
    return {
      creationActive: false,
      deleteActive: false,
      edit: {
        processing: false,
        contract: undefined,
        index: undefined,
      },
      del: {
        processing: false,
        contract: undefined,
        index: undefined,
      },
    };
  },
  computed: {
    contracts() {
      return this.$store.getters.contracts;
    },
  },
  methods: {
    toggleCreationActive() {
      this.creationActive = !this.creationActive;
      if (this.creationActive === false) {
        this.edit = {
          contract: undefined,
          index: undefined,
        };
      }
    },
    initiateEdit(item, index) {
      this.edit.contract = item;
      this.edit.index = index;
      this.toggleCreationActive();
    },
    initiateDelete(item, index) {
      this.del.contract = item;
      this.del.index = index;
    },
    closeDelete() {
      this.del = {
        processing: false,
        contract: undefined,
        index: undefined,
      };
    },
    async confirmDelete() {
      this.del.processing = true;
      await this.$store.dispatch("updateConfig", {
        key: {
          userId: this.$store.state.user.userId,
          tenantId: this.$store.state.user.tenantId,
        },
        index: this.del.index,
        category: "contracts",
        operation: "delete",
        api_version: this.$store.state.businessSettings.api_version,
      });
      this.closeDelete();
    },
    async callDb(subject) {
      this.edit.processing = true;
      let updatePacket = {
        key: {
          userId: this.$store.state.user.userId,
          tenantId: this.$store.state.user.tenantId,
        },
        subject: subject,
        category: "contracts",
        api_version: this.$store.state.businessSettings.api_version,
      };
      if (this.edit.index) {
        updatePacket = {
          ...updatePacket,
          operation: "edit",
          index: this.edit.index,
        };
      } else {
        updatePacket = {
          ...updatePacket,
          operation: "add",
        };
      }
      await this.$store.dispatch("updateConfig", updatePacket);
      this.toggleCreationActive();
      this.edit.processing = false;
    },
  },
  created() {},
  components: {
    ItemTile,
    ContractCreation,
    ContractDelete,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #config-contracts-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-items: flex-start;
    box-sizing: border-box;
  }

  .contract-item {
    margin: 20px;
    background-color: var(--secondaryColor);
  }
  @media (min-width: 800px) {
    .contract-item {
      margin: 30px;
    }
  }
}
</style>
